import addCheckpoint from './add-checkpoint';

export default {
  addCheckpoint,
};
